import { useId, useMemo, useRef, useState } from "react"
import styles from "./TagSelector.module.css"
import { ReactComponent as CloseIcon } from "../assets/images/icons/ic-close.svg"
import { ReactComponent as ChevronIcon } from "../assets/images/icons/ic-chevron.svg"
import useClickOutside from "../common/hooks/useClickOutside"

const TagSelector = ({ selected = [], options = [], placeholder = "Cerca o seleziona tag", style, onRemove = () => {}, onAdd = () => {} }) => {
    const [value, setValue] = useState('')
    const [open, setOpen] = useState(false)
    const ref = useRef(null)
    const inputRef = useRef(null)
    const id = useId()
    useClickOutside(ref, () => setOpen(false))
    const filtered = useMemo(() => options.filter(item => !selected.some(tag => tag.id === item.id) && item.name.toLocaleLowerCase().includes(value.trim().toLocaleLowerCase())).sort((a, b) => a.name.localeCompare(b.name)), [options, selected, value])
    const add = item => { onAdd(item); setValue(''); inputRef.current?.focus(); setOpen(false) }
    return <div className={styles.container} ref={ref} style={style}>
        <div className={styles.control}>
            {selected.map(item => <span className={styles.chip} key={item.id}><span className={styles.dot} style={{ background: item.color || 'var(--primary)' }} />{item.name}<button type="button" aria-label={`Rimuovi ${item.name}`} onClick={() => onRemove(item)}><CloseIcon /></button></span>)}
            <input ref={inputRef} aria-label="Cerca tag" aria-expanded={open} aria-controls={id} value={value} placeholder={placeholder || "Aggiungi tag"} onFocus={() => setOpen(true)} onChange={event => { setValue(event.target.value); setOpen(true) }} onKeyDown={event => {
                if (event.key === 'Escape') setOpen(false)
                if (event.key === 'Enter' && open && filtered.length === 1) { event.preventDefault(); add(filtered[0]) }
            }} />
            <button type="button" className={styles.toggle} aria-label="Mostra tag" aria-expanded={open} onClick={() => setOpen(!open)}><ChevronIcon /></button>
        </div>
        {open && <div id={id} className={styles.options}>
            {filtered.length ? filtered.map(item => <button type="button" key={item.id} className={styles.option} onClick={() => add(item)}><span className={styles.dot} style={{ background: item.color || 'var(--primary)' }} />{item.name}</button>) : <div className={styles.empty}>Nessun tag disponibile</div>}
        </div>}
    </div>
}
export default TagSelector
